import {Component, EventEmitter, Input, OnInit, Output, ViewChild,} from '@angular/core';
import {FormControl} from '@angular/forms';
import {MatSelect} from '@angular/material/select';
import {MatSelectFilterComponent} from 'mat-select-filter';
import {SearchObject} from 'src/app/domain/search/SearchObject';
import {AppeloffreService} from 'src/app/modules/services/appel-offre/appeloffre.service';
import {SearchObjectService} from 'src/app/modules/services/search-object/SearchObjectService';
import {AppTranslateService} from 'src/app/modules/services/translate/app-translate.service';
import {ToastService} from 'src/app/modules/toast/toast.service';
import {hasrequiredField} from 'src/app/utils/Hasrequired';

@Component({
    selector: 'app-combo-acheteur-etat',
    templateUrl: './combo-acheteur-etat.component.html',
    styleUrls: ['./combo-acheteur-etat.component.css'],
})
export class ComboAcheteurEtatComponent implements OnInit {
    @Output() object = new EventEmitter<any>();
    @Output() annulation = new EventEmitter<any>();

    @Input() control: FormControl;
    @Input() label = 'test';
    searchObject: SearchObject = new SearchObject();
    list: any[] = [];
    listsearch: any[] = [];
    isLoading = false;
    required = hasrequiredField;
    @ViewChild('MatSelect') select: MatSelect;
    @Input() muliple = false;
    @ViewChild(MatSelectFilterComponent) filter: MatSelectFilterComponent;

    constructor(
        private offerservice: AppeloffreService,
        private appTranslateService: AppTranslateService,
        private toastService: ToastService,
        private searchObjectService: SearchObjectService
    ) {
    }

    get isReady() {
        return Array.isArray(this.list);
    }

    ngOnInit(): void {
        this.fetchlist();
    }

    change(e) {
        this.filter?.searchForm.reset();
        // this.filter.filteredReturn.emit(this.options)
        // this.filter.input=""
        this.object.emit(e);
    }

    getlang() {
        return this.appTranslateService.getDefaultLang();
    }

    clear($event: MouseEvent) {
        $event.stopPropagation();
        this.control.setValue(undefined);
        this.annulation.emit();
    }

    ngAfterViewInit(): void {
        this.fetchlist();
    }

    private fetchlist() {
        this.isLoading = true;

        //this.searchObject.listCol=['instRegNo','instNm','instNmAr'];

        /* this.searchObject.dataSearch.push( new CriteriaSearch(
          'delFl',
          'Y' || undefined,
          '!='
        ),
        ) */
        this.offerservice.getAcheteurListEtat(this.searchObject).subscribe({
            next: (response) => {
                this.list = response['payload']['data'];

                this.listsearch = response.payload.data;

                this.listsearch?.map(
                    (item) =>
                        (item.motcle =
                            item.instNmAr + '' + item.instNm + ' ' + item.instNmFr)
                );
            },
            error: (e) => {
                this.toastService.error();

                this.isLoading = false;
            },
            complete: () => {
                this.isLoading = false;
            },
        });
    }
}
